import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheSonicIdentity() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-sonic-identity" ref={sectionRef} className="dark bg-background text-foreground py-32 md:py-48 relative overflow-hidden w-full">
      {}
      <div className="absolute left-0 md:left-[40%] top-0 bottom-0 w-px h-full hidden md:block">
        <Separator orientation="vertical" className="h-full bg-border/10 w-px" />
      </div>

      <div className="container mx-auto px-6 h-full">
        <div className="flex flex-col md:flex-row h-full">
          {}
          <div className="w-full md:w-[40%] flex md:justify-end md:pr-12 items-center justify-start mb-12 md:mb-0 relative">
            <div className={cn("transition-all duration-1000 delay-300 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
              <span className="block md:rotate-180 md:[writing-mode:vertical-rl] text-muted-foreground/40 text-xs md:text-sm tracking-[0.3em] font-mono uppercase whitespace-nowrap">
                EST. PERFORMANCE
              </span>
            </div>
          </div>

          {}
          <div className="w-full md:w-[60%] flex flex-col justify-center md:pl-20 lg:pl-32">
            <div className="max-w-2xl">
              <h2 className="font-serif text-4xl leading-[1.1] mb-8 transition-all duration-1000 delay-500 ease-out opacity-100 translate-y-0 !text-[hsl(50,98%,64%)] md:text-[48px]">
                The Sonic Identity
              </h2>
              
              <div className={cn("space-y-6 transition-all duration-1000 delay-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
                <p className="font-sans text-base md:text-[18px] leading-relaxed text-muted-foreground">
                  Born to dominate the auditory landscape, DJ Taurx represents the pinnacle of elite performance. 
                  Every set is a calculated masterpiece, engineered with high-end precision using industry-standard 
                  CDJ 3000s and the A9 Mixer.
                </p>
                <p className="font-sans text-base md:text-[18px] leading-relaxed text-muted-foreground">
                  We don't just play music; we construct an immersive environment where luxury meets 
                  technical prowess. This is the new standard for sonic excellence—sharp, uncompromising, 
                  and unforgettable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}